import { render, staticRenderFns } from "./prodInfo.vue?vue&type=template&id=5190af7f&"
import script from "./prodInfo.vue?vue&type=script&lang=js&"
export * from "./prodInfo.vue?vue&type=script&lang=js&"
import style0 from "./prodInfo.vue?vue&type=style&index=0&id=5190af7f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports